import React from 'react';

const Footer = () => {


  return (
     <div style={{height:80}} >
     </div>
  )
};

export default Footer;
